import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  text_scale: string;
};

const initialState: InitialState = {
  text_scale: "",
};

const displaySizeSlice = createSlice({
  name: "displaySize",
  initialState,
  reducers: {
    setDisplaySize(state, action: PayloadAction<{ text_scale: string }>) {
      state.text_scale = action.payload.text_scale;
    },
  },
});

export const { setDisplaySize } = displaySizeSlice.actions;

export default displaySizeSlice;
